type MD5ValidatorOptions = {
    ignoreEmpty?: boolean;
};

export const validateMD5 = (message: string, options?: MD5ValidatorOptions) => {
    return (value: unknown) => {
        if (options?.ignoreEmpty === true) {
            if (value === undefined || value === null || value === '') {
                return; // Passthrough for other validators if empty
            }
        }
        const md5Regex = new RegExp(/^[a-zA-Z0-9]{10,32}$/);
        const isValid = typeof value === 'string' && md5Regex.test(value);
        if (!isValid) {
            return message;
        }
    };
};
